/**
 * 票種顯示名 —— 單一班次購買頁與套票購買頁共用。
 *
 * 抽出來的原因跟 CMS 那次一樣：業主價目表把兒童分成 3-5 / 6-11 兩段
 * （migration 20260819050000）之後，這份 fallback 表沒跟上，於是那兩個票種在
 * 畫面上顯示成原始代碼 `child_6_11`。各頁各寫一份的話，只會有其中一頁記得補。
 */

import type { SellableTicketType } from './api-client';

/** 定價規則未設 `display_name_i18n` 時的中文名。 */
const TICKET_LABEL_FALLBACK: Record<string, string> = {
  adult: '成人',
  senior: '敬老',
  child: '兒童',
  child_6_11: '兒童 6-11 歲',
  child_3_5: '兒童 3-5 歲',
  infant: '嬰兒',
  early_bird: '早鳥',
  package_family: '家庭套票',
  custom: '其他',
};

/** 規則有設多語名就用它；否則退回中文對照；再不然原樣顯示代碼。 */
export function ticketLabel(tt: SellableTicketType, locale: string): string {
  const dn = tt.display_name_i18n;
  if (dn) {
    const v = dn[locale] ?? dn['zh-TW'] ?? Object.values(dn)[0];
    if (v) return v;
  }
  return TICKET_LABEL_FALLBACK[tt.ticket_type] ?? tt.ticket_type;
}
